<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="'日報'" />
		<CommonFlame :title="'日報テンプレート一覧'">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<TemplateNewDialog
					text
					v-if="authorized && metaTypes.length"
					:metaTypes="metaTypes"
					:polymorphicOptions="polymorphicOptions"
					:optionTypes="optionTypes"
					@add-template="templates.unshift($event)"
				/>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters class="pa-2" justify="end">
					<TemplateNewDialog
						v-if="authorized && metaTypes.length"
						:authorized="authorized"
						:polymorphicOptions="polymorphicOptions"
						:optionTypes="optionTypes"
						:metaTypes="metaTypes"
						@add-template="templates.unshift($event)"
					/> </v-row
			></template>

			<div class="table-container px-2 mt-4">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="templates"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="fetchTemplate(item.id)" class="clickable">
							<td>{{ item.name }}</td>
							<td>{{ item.department.name }}</td>
							<td>{{ datetimeFormat(item.created_at) }}</td>
							<td>{{ datetimeFormat(item.updated_at) }}</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<TemplateShowDialog
				v-if="selectedTemplate != null"
				:templateData.sync="selectedTemplate"
				:authorized="authorized"
				:metaTypes="metaTypes"
				:polymorphicOptions="polymorphicOptions"
				:optionTypes="optionTypes"
				@close-dialog="selectedTemplate = null"
				@set-selected-template="selectedTemplate = $event"
				@reload-templates="fetchTemplates(pagination.current)"
				@update-template="updateTemplate($event)"
			/>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import moment from "moment/min/moment.min.js"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"
import PaginationModule from "../shared/PaginationModule.vue"
import TemplateShowDialog from "./components/DailyReportTemplateShowDialog.vue"
import TemplateNewDialog from "./components/DailyReportTemplateNewDialog.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		PaginationModule,
		TemplateShowDialog,
		TemplateNewDialog,
		FunctionTitle,
		CommonFlame,
	},
	data() {
		return {
			department_id: this.$route.params.department_id,
			department: { name: null },
			templates: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			selectedTemplate: null,
			metaTypes: [],
			optionTypes: [],
			polymorphicOptions: [],
			authorized: false,
			headers: [
				{ text: "テンプレート名", value: "name", width: "200px", divider: true },
				{ text: "部門", value: "department.name", width: "200px", divider: true },
				{ text: "作成日", value: "created_at", width: "150px", divider: true },
				{ text: "最終変更日", value: "updated_at", width: "150px", divider: true },
			],
		}
	},
	mounted() {
		authenticate.authenticateUser()
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.fetchTemplates(page)
	},
	methods: {
		fetchTemplates(page) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/departments/${this.department_id}/daily_report_templates`
			axios
				.get(url, { headers, params: { page } })
				.then((res) => {
					this.templates = res.data.templates
					this.pagination = res.data.pagination
					this.department = res.data.department
					this.authorized = res.data.authorized
					this.optionTypes = res.data.option_types
					this.polymorphicOptions = res.data.polymorphic_options
					this.metaTypes = res.data.meta_types
				})
				.catch((err) => errorHandling.errorResponse(err))
		},
		getPage(i) {
			this.fetchTemplates(i)
			this.$router.push({
				name: "daily_report_template_index",
				query: { page: i },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		fetchTemplate(id) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/daily_report_templates/${id}`
			axios
				.get(url, { headers })
				.then((res) => {
					this.selectedTemplate = res.data.template
				})
				.catch((err) => errorHandling.errorResponse(err))
		},
		updateTemplate(template) {
			const oldTemplate = this.templates.find((t) => t.id == template.id)
			const index = this.templates.indexOf(oldTemplate)
			this.selectedTemplate = template
			this.$set(this.templates, index, template)
		},
	},
	computed: {
		datetimeFormat() {
			return (datetime) => {
				if (!datetime) return null
				return moment(datetime).format("YYYY/MM/DD HH:mm")
			}
		},
	},
}
</script>
